<template>
    <div id="content">
        <loader v-if="loading"></loader>
        <div v-else>
            <div class="card mt-3">
                <div class="card-header">
                    Matrix

                  <b-button @click.stop="load" variant="outline-primary" class="float-right">Reload</b-button>
                </div>
                <div class="card-body p-0">
                    <GmapMap ref="map"  :options="{
                                   zoomControl: true,
                                   mapTypeControl: false,
                                   scaleControl: false,
                                   streetViewControl: false,
                                   rotateControl: false,
                                   fullscreenControl: true,
                                   disableDefaultUI: false
                                }"
                             :zoom="10"
                             :center="{lat:41.100132, lng:29.057549}"
                             id="map">

                        <GmapMarker v-if="google" :position="new google.maps.LatLng(40.543782, 28.255775)"
                                    :icon="{ url: require('../../../../assets/cemuk.png')}"/>
                        <div v-if="drivers.length > 0">
                            <cmarker v-for="driver in drivers" :key="driver.user.id" :marker="{lat: driver.location.coordinates[1], lng: driver.location.coordinates[0]}">
                                <span v-if="driver">
                                    <b-icon v-if="driver.heading" :rotate="driver.heading" :id="'user'+driver.user.id" scale="1.5" icon="arrow-up-circle-fill" variant="dark"></b-icon>
                                <b-popover :target="'user'+driver.user.id" triggers="hover" placement="top">
                                    <template v-slot:title>
                                        <router-link :to="{ name: 'userDetail', params: { id: driver.user.id }}">{{driver.user.name +' '+ driver.user.surname}} - {{driver.level.name}}</router-link>
                                    </template>
                                    <div><small>{{driver.vehicle.manufacturer}} {{driver.vehicle.model}} - {{driver.vehicle.year}}</small></div>
                                    <div><small><strong>Phone:</strong> {{driver.user.phoneNumber}}</small></div>
                                    <div><small><strong>Plate:</strong> {{driver.vehicle.plate}}</small></div>
                                    <div><small><strong>Speed:</strong> {{(Number(driver.speed) * 3.6).toFixed(0)}}kmh</small></div>
                                </b-popover>
                                </span>
                            </cmarker>
                        </div>
                    </GmapMap>
                </div>
            </div>
            <DriverStatusComponent v-if="drivers.length > 0" :onlineDrivers="drivers" />
        </div>

    </div>
</template>

<script>
    import ContentLoader from '../../../../components/ContentLoader';
    import TripMatrixEnter from '../../../../store/actions/tripMatrixEnter';
    import GetHeatmap from '../../../../store/actions/getHeatmap';
    import ShowError from '../../../../helpers/showError';
    import {gmapApi} from 'vue2-google-maps';
    import GmapCustomMarker from 'vue2-gmap-custom-marker';
    import DriverStatusComponent from "./DriverStatusComponent";

    export default {
        name: 'Matrix',
        components: {
            loader: ContentLoader,
            cmarker: GmapCustomMarker,
            DriverStatusComponent,
        },
        computed: {
            google: gmapApi
        },
        sockets: {
            connect: function () {
                this.load(true);
            },
          /*
            LOCATION_UPDATE: async function (data) {
                if(this.updating) return;
                const driver = this.drivers.find(driver => driver.user.id === data.userId);
                if(driver) {
                    const indexOf = this.drivers.indexOf(driver);
                    driver.speed = data.location.speed;
                    driver.heading = data.location.heading;
                    driver.location = {
                        type: 'Point',
                        coordinates: [data.location.longitude, data.location.latitude]
                    }
                    if(this.updating) return;
                    this.$set(this.drivers, indexOf, driver);
                }
            },*/
          DRIVER_OFFLINE: async function(data) {
                if(this.updating) return;
                const driver = this.drivers.find(driver => driver.user.id === data.userId);
                if(driver) {
                    if(this.updating) return;
                    this.drivers.splice(this.drivers.indexOf(driver), 1)
                }
            },
            DRIVER_ONLINE: async function(data) {
                if(this.updating) return;
                this.drivers.push(data);
            }
        },
        created() {
            this.load();
        },
        mounted() {
            this.$nextTick(() =>{
                this.heatmap();
            })
        },
        data() {
            return {
                drivers: [],
                loading: true,
                updating: false
            }
        },
        methods: {
            async load(slient = false) {
                try {
                    if(!slient) this.loading = true;
                    this.updating = true;
                    this.drivers = [];
                    this.drivers = await TripMatrixEnter();
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                    this.updating = false;
                }
            },
            async heatmap(){
                const result = await GetHeatmap();
                await this.$gmapApiPromiseLazy();
                const points = result.map(item => {
                    const json = JSON.parse(item);
                    return {location: new window.google.maps.LatLng(json.coordinates[1], json.coordinates[0]), weight: 100};
                })

                this.$refs.map.$mapPromise.then((map) => {
                    new window.google.maps.visualization.HeatmapLayer({
                        data: points,
                        map: map
                    });
                })

            }
        }
    }
</script>

<style scoped>
    #map {
        width: 100%;
        height: 550px;
    }
</style>